// extracted by mini-css-extract-plugin
module.exports = {"OrderItem":"OrderItem_OrderItem__3thcL","Items":"OrderItem_Items__2qDyN","Price":"OrderItem_Price__1AKdr","Date":"OrderItem_Date__3OavS"};